namespace TabAurous.OMS {
    export interface SettingsRow {
        Id?: number;
        Name?: string;
        Description?: string;
        Value?: string;
        Type?: string;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
    }

    export namespace SettingsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'OMS.Settings';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            Description = "Description",
            Value = "Value",
            Type = "Type",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date"
        }
    }
}
